import { useCallback, useEffect, useState } from 'react';
import { sendApiRequest } from 'lib/api/public';

export type ConnectionStatus = 'connected' | 'reconnect_required' | 'not_connected';

export type Connection = {
  id: string | null;
  type: string;
  label: string;
  email: string;
  ownerUserId: string | null;
  ownerName: string;
  status: ConnectionStatus;
  occurredAt: string | null;
  connectPath: string;
  emailAccountId?: string;
};

export function useConnections({ enabled = true }: { enabled?: boolean } = {}) {
  const [connections, setConnections] = useState<Connection[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // isLoading only covers the first load so refetches update rows in place without blanking the table.
  const refetch = useCallback(async () => {
    try {
      const response = await sendApiRequest<Connection[]>({
        path: '/integrations/connections',
        method: 'GET',
      });
      setConnections(Array.isArray(response) ? response : []);
    } catch {
      setConnections([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false);
      return;
    }

    void refetch();
  }, [enabled, refetch]);

  return { connections, isLoading, refetch };
}
